import { api } from "../../../infra/api";
import { URLS } from "../../../infra/URLS";

export async function getTokenUpload(ClienteId: number, Arquivos : string) {
  if (Arquivos){
    const { data } = await api.get(
      `${URLS.ARQUIVOS_UP_TOKEN_API}?ClienteId=${ClienteId}&Arquivo=${Arquivos}`
    );

    console.log('Token: ', data)
    return data;
  }
  return ;
}